export enum DistributionType {
    DISTRIBUTION = 'DISTRIBUTION',
    TEMPLATE = 'TEMPLATE'
}
